export const B = {
  brown:"#5D4A3B", brownL:"#8A7867", brownD:"#1C1814",
  taupe:"#6F6256", stone:"rgba(28,24,20,0.68)", sand:"#F1E7D6",
  gold:"#A98A5F", ivory:"#FAF8F5", cream:"#EDE2CC",
  white:"#FFFDFC", black:"#1C1814", char:"#2A221B",
};

export const LOGO = "https://media.base44.com/images/public/69d96446735f4e1f0f7d5bbf/4af79f86a_1.png";
export const BOOKING_URL = "https://www.fresha.com/el/a/ikonomakis-hair-atelier-halandri-irakleitoy-80-bxynmijf";